import { Box, useTheme } from '@mui/material';
import { Link1 } from 'iconsax-react';
import type { ReactElement } from 'react';

export const LinkRoundIcon = (): ReactElement => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.SlabGray.Stroke}`,
        backgroundColor: theme.palette.SlabGray[0],
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        right: '50%',
        transform: 'translateX(50%)',
        bottom: -25,
        zIndex: 1,
      }}
    >
      <Link1 size={20} variant='TwoTone' color={theme.palette.SlabIndigo[500]} />
    </Box>
  );
};
